import { Injectable } from '@angular/core';
import { UserOperation } from '../../../../../core/enums/user-operation';
import { FormGroup } from '@angular/forms';
import { TimeBlockContentType, TimeBlockDialogItem } from '../types/time-block-types';
import { ShiveDialogService } from '../../../../../core/services/controls/shive-dialog.service';
import { TimeBlockHydrationService } from '../generation/time-block-hydration.service';
import { TimeBlockHttpService } from '../../../../../core/state/time-blocks/time-block-entries/time-block-http.service';

/** This service is also used for the absence planner **/
@Injectable()
export class DialogHttpRequestHandlerService {
  constructor(
    private readonly timeBlockHttpService: TimeBlockHttpService,
    private readonly shiveDialogService: ShiveDialogService,
    private readonly timeBlockHydrationService: TimeBlockHydrationService,
  ) {}

  public init(
    form: FormGroup,
    timeBlockContentType: TimeBlockContentType,
    timeBlockDialogItem: TimeBlockDialogItem,
    isFixInterval: boolean,
  ): void {
    if (!form.valid) {
      form.markAllAsTouched();
      return;
    }

    if (!timeBlockDialogItem.timeBlockItem) {
      throw new Error(`Invalid time block item: ${timeBlockDialogItem.timeBlockItem}`);
    }

    const timeBlock = timeBlockDialogItem.timeBlockItem;
    timeBlock.timeBlockContentType = timeBlockContentType;

    if (timeBlockDialogItem.operation === UserOperation.Delete) {
      this.timeBlockHttpService.deleteBlock(timeBlockDialogItem.timeBlockItem.id);
    } else {
      // Hydrate only for Create or Update
      timeBlock.timeBlockModel = this.timeBlockHydrationService.hydrateTimeBlockModel(
        timeBlock,
        form.controls,
        isFixInterval,
      );

      if (timeBlockDialogItem.operation === UserOperation.Create) {
        this.timeBlockHttpService.postTimeBlock(timeBlock);
      } else if (timeBlockDialogItem.operation === UserOperation.Update) {
        this.timeBlockHttpService.putTimeBlock(timeBlock);
      }
    }
    this.shiveDialogService.close(timeBlockDialogItem.operation);
  }
}
